import axios from 'axios';
import { BACKEND_URL } from './backend';

const API = BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry && !error.config.url?.includes('/auth/')) {
      error.config._retry = true;
      try {
        const { data } = await axios.post(`${API}/api/auth/refresh`, {}, { withCredentials: true });
        if (data?.token) {
          localStorage.setItem('token', data.token);
          error.config.headers = error.config.headers || {};
          error.config.headers.Authorization = `Bearer ${data.token}`;
        }
        return api(error.config);
      } catch {
        localStorage.removeItem('token');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
